import { render, staticRenderFns } from "./how-does-it-work.vue?vue&type=template&id=0f582086"
import script from "./how-does-it-work.vue?vue&type=script&lang=js"
export * from "./how-does-it-work.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports